import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbDnsRecordsQuery } from '../../DnsRecords';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicDnsRecordsByIdBreadcrumb: BreadcrumbComponentType<'dnsRecordId'> = ({ match }) => {
  const dnsRecordId = useMemo(() => match.params.dnsRecordId ?? '', [match.params.dnsRecordId]);

  const breadcrumbQuery = useBreadcrumbDnsRecordsQuery(dnsRecordId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicDnsRecordsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>DNS записи</span>;
};

export const DynamicDnsRecordsBreadcrumb = {
  DynamicDnsRecordsByIdBreadcrumb,
  DynamicDnsRecordsListBreadcrumb
};
